// The brand mark: a "P" (Pratik) drawn like a GPS route — start dot,
// a heartbeat kink in the stem, and a tennis-ball comet at the end of the line.
import { ACCENT, FG } from "../theme";

export const LOGO_PATH =
  "M38 104 C37 94 35 84 35 76 L44 68 L28 58 L35 50 L35 32 Q35 16 51 16 L64 16 Q90 16 90 38 Q90 60 64 60 L46 60";

const FitLogo = ({ size = 44, animate = true, stroke = FG, ball = ACCENT, strokeWidth = 10 }) => (
  <svg width={size} height={size} viewBox="0 0 120 120" aria-label="Pratik Chawla logo" role="img">
    {animate && (
      <style>{`
        .fitlogo-draw {
          stroke-dasharray: 340;
          stroke-dashoffset: 340;
          animation: fitlogo-dash 1.6s cubic-bezier(0.65, 0, 0.35, 1) forwards;
        }
        .fitlogo-comet {
          opacity: 0;
          transform-origin: 46px 60px;
          animation: fitlogo-pop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 1.45s forwards;
        }
        @keyframes fitlogo-dash { to { stroke-dashoffset: 0; } }
        @keyframes fitlogo-pop { from { opacity: 0; transform: scale(0.2); } to { opacity: 1; transform: scale(1); } }
        @media (prefers-reduced-motion: reduce) {
          .fitlogo-draw { stroke-dashoffset: 0; animation: none; }
          .fitlogo-comet { opacity: 1; animation: none; }
        }
      `}</style>
    )}
    <path
      className={animate ? "fitlogo-draw" : undefined}
      d={LOGO_PATH}
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="38" cy="104" r="5" fill={ball} />
    <circle className={animate ? "fitlogo-comet" : undefined} cx="46" cy="60" r="8.5" fill={ball} />
  </svg>
);

export default FitLogo;
